export const calculatePercentage = (value: number, total: number) => {
  return (100 / total) * value;
};

/**
 * A segment's share of the bar, as a CSS width.
 *
 * In percent rather than measured pixels, so the bar is laid out by the browser at whatever width
 * its row has — including the printed page, where nothing re-measures before the snapshot.
 */
export const calculateWidth = (value: number, total: number) =>
  `${calculatePercentage(value, total)}%`;

/** Where a mean on the five-point scale falls along the bar, as a percentage of its width. */
export const calculateMarkerPercentage = (value: number) =>
  calculatePercentage(value - 1, 4);

/**
 * The marker's CSS offset, kept 5px inside either end of the bar so it is never drawn half off it.
 */
export const calculateMarkerOffset = (value: number) =>
  `clamp(5px, ${calculateMarkerPercentage(value)}%, calc(100% - 5px))`;
